import { isMultiLine } from '@/utils/text/isMultiLine';

// the right space is preferred
//  hence Math.ceil and first check to the right
// only for texts without line breaks
export const findCenterMostSpaceIndex = (text: string) => {
  if (isMultiLine(text)) {
    return -1;
  }

  const center = Math.ceil(text.length / 2);
  for (let i = 0; i <= center; i++) {
    const toTheRight = center + i;
    if (text[toTheRight] === ' ') {
      return toTheRight;
    }

    const toTheLeft = center - i;
    if (text[toTheLeft] === ' ') {
      return toTheLeft;
    }
  }

  return -1;
};
